// Lightweight GA4 event helpers. gtag is loaded in public/index.html.
// Fires a standard GA4 "generate_lead" event on successful lead submissions so it
// can be imported into Google Ads as a conversion (Ads <-> GA4 link, no code IDs).
export function trackLead(source = "form") {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "generate_lead", {
        form_source: source,
        value: 1,
        currency: "USD",
      });
    }
  } catch (_) {
    /* no-op */
  }
}

// Optional: call when a phone (tel:) link is clicked, for call-click conversions.
export function trackCallClick(source = "phone_link") {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "phone_call_click", { source });
    }
  } catch (_) {
    /* no-op */
  }
}


export function trackSmsClick(source = "sms_link") {
  try {
    if (typeof window !== "undefined" && typeof window.gtag === "function") {
      window.gtag("event", "sms_click", { source });
    }
  } catch (_) {
    /* no-op */
  }
}
